/**
 * Agent logo icon - the Leela AI assistant branding mark.
 */
import React from 'react';
import agentLogo from 'src/assets/agent-logo.svg';

interface AgentIconProps {
  size?: number;
}

export const AgentIcon: React.FC<AgentIconProps> = ({ size = 20 }) => (
  <img alt="" height={size} src={agentLogo} style={{ verticalAlign: 'middle' }} width={size} />
);
